export default __webpack_public_path__ + "static/media/password.ef6032ce.svg";